import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';
import { HeaderVisibilityConfiguration } from 'app/components';
import { RenderMode, AuthState } from 'app/types-shared';

const visibilityConfigPerRenderMode: { [key:string]: HeaderVisibilityConfiguration } = {
  [RenderMode.report]: {
    meatballMenu: { open: true, edit: true, delete: true, duplicate: true, bowtie: true, share: true, print: true, 
      lossPotential: true, residualLossPotential: true }
  },
  [RenderMode.read]: {
    panel: { edit: true },
    meatballMenu: { open: false, delete: true, duplicate: true, bowtie: true, share: true, print: true, 
      lossPotential: true, residualLossPotential: true }
  },
  [RenderMode.edit]: {
    meatballMenu: { changeCaseType: true, submitAndContinue: true }
  }
};

export const headerVisibilityConfiguration = 
  (state: CaseState | CaseListingInstanceState, uiEngineProps: ConnectedComponentProps, applicationState):
    { headerVisibilityConfiguration: HeaderVisibilityConfiguration } => {

    const authState = uiEngineProps.sharedState && uiEngineProps.sharedState.authState as AuthState;
    if (authState === AuthState.Anonymous) {
      return { headerVisibilityConfiguration: { panel: { edit: true } } };
    }

    const { headerVisibilityConfiguration: visibilityConfig } = uiEngineProps.hostProps();
    const { renderMode } = state;

    return {
      headerVisibilityConfiguration: visibilityConfig || visibilityConfigPerRenderMode[renderMode]
    };
  };
